import Vue from 'vue'
import { Tooltip } from 'ant-design-vue'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <div class="custom-tooltip cell-ellipsis">
        <a-tooltip placement="right" :title="formatCurrency(value)">
          <span style="text-align: right; display: block;"> {{ formatCurrency(value) }}</span>
        </a-tooltip>
      </div>`,
  data: function () {
    return {
      value: '',
      currency: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
    switch (this.params.name) {
      case 'indirect':
        this.value = this.params.value || undefined
        break

      default:
        this.value = this.params.value
        break
    }
  },
  methods: {
    // Format Currency
    formatCurrency(cost) {
      if (cost !== undefined && cost !== '' && cost !== 'Total' && cost !== null) {
        const value = parseFloat((cost)).toFixed(2)
        return new Intl.NumberFormat(this.currency.currencyFormate, { style: 'currency', currency: this.currency.currency }).format(value)
      }
      if (cost === 'Total') {
        return cost
      }
    },
    getValue() {
      return this.params.value
    },
  },
})
